import Card from "../../../design-system/Card";
import Card2 from "../../../design-system/CardList";
import { SeedType } from "../../../utils/common";

interface SummaryProps {
    summary: {
        background: string;
        scenario: string;
        outcome: string;
        possibleCurrentStates?: string[];
        desiredTransformationGoal?: string[];
    };
    published: boolean;
}

const Summary = ({ summary, published }: SummaryProps) => {
    const summaryData = summary;
    return (
        <div className="">
            {summaryData.background ? <Card title="Background" content={summaryData.background} published={published} /> : ""}
            {summaryData.scenario ? <Card title="Scenario" content={summaryData.scenario} published={published} /> : ""}
            {summaryData.outcome ? <Card title="Outcome" content={summaryData.outcome} published={published} /> : ""}
            <div className="sm:flex sm:space-x-4">
                {summaryData.possibleCurrentStates ? <Card2 title="Possible Current States" content={summaryData.possibleCurrentStates} /> : ""}
                {summaryData.desiredTransformationGoal ? <Card2 title="Desired Transformation (Goal)" content={summaryData.desiredTransformationGoal} /> : ""}
            </div>
        </div>
    );
};

export default Summary;
